<template>
  <base-credit-card :host-field-id="containerName"
                    :title="'cvv'"
                    :error-message="cvv.error"
                    :focused="focused"
                    :empty="cvv.isEmpty"/>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';

import BaseCreditCard from '../../../subscription/components/credit-card-fields/BaseCreditCard.vue';

export default {
  name: 'CVV',
  components: {
    BaseCreditCard,
  },
  data() {
    return {
      containerName: 'cvv-container',
      blurredOnce: false,
      focused: false,
    };
  },
  async mounted() {
    const cvc = this.fields.create(window.PayMe.fields.CVC, {
      placeholder: ' ',
      styles: {
        base: {
          'font-size': '20px',
          'text-align': 'right',
          color: '#2b323b',
          '::placeholder': {
            color: '#9b9b9b',
          },
        },
      },
    });
    cvc.mount(`#${this.containerName}`);

    cvc.on('keyup', this.setKeyUpResult);
    cvc.on('validity-changed', this.setKeyUpResult);
    cvc.on('blur', this.markAsBlurred);
    cvc.on('focus', this.markAsFocused);
  },
  computed: {
    ...mapState('payment', ['fields', 'creditCard']),
    ...mapGetters('payment', ['creditCardFields']),
    cvv() {
      return this.creditCard[this.creditCardFields.cvv];
    },
  },
  methods: {
    ...mapActions('payment', ['setCreditCardField']),
    setKeyUpResult(event) {
      const { isValid, isEmpty } = event;
      this.setCreditCardField({ field: this.creditCardFields.cvv, isValid, isEmpty });
    },
    markAsBlurred() {
      this.blurredOnce = true;
      this.focused = false;
    },
    markAsFocused() {
      this.focused = true;
    },
  },
};
</script>
